<template>
    <v-dialog v-model="controls.showDialog" scrollable>
        <template v-slot:activator="{on: dialog}">
            <v-tooltip bottom>
                <template v-slot:activator="{on: tooltip}">
                    <v-btn v-on="{...tooltip, ...dialog}" class="white--text" :small="icon" :outlined="icon" color="green" :fab="icon">
                        <v-icon v-if="icon">add</v-icon>
                        <span v-else>Create Order</span>
                    </v-btn>
                </template>
                <span>Create an order {{manifest ? 'from this manifest' : ''}}</span>
            </v-tooltip>
        </template>
        <v-card :loading="controls.loading">
            <v-card-actions class="pt-0 pb-0">
                <CaSampleTypeDropdown @selected="setSampleTypes" label="Set all sample types to:" filled dense>
                </CaSampleTypeDropdown>
                <v-spacer></v-spacer>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-stepper v-model="controls.currentStep"  non-linear alt-labels>
                    <!--          STEPPER HEADER          -->
                    <v-stepper-header>
                        <template v-for="(sample, index) in form.samples">
                            <v-stepper-step
                                    :key="sample.qa"
                                    :step="index + 1"
                                    editable
                                    color="primary"
                                    class="pt-2 pb-2 pt-2 pl-2"
                            >
                                {{sample.qa}}
                            </v-stepper-step>
                        </template>
                        <v-stepper-step
                                :step="steps"
                                editable
                                color="primary"
                                class="pt-2 pb-2 pt-2 pl-2"
                        >
                            New Sample
                        </v-stepper-step>
                    </v-stepper-header>
                    <!--          STEPPER CONTENTS/ITEMS          -->
                    <v-stepper-items>
                        <template
                                v-for="(sample, index) in form.samples"
                        >
                            <v-stepper-content
                                    :key="index.qa"
                                    :step="index +1"
                            >
                                <CaOrderSampleForm :sample_data="sample" @newsample="updateSample(sample, $event)"></CaOrderSampleForm>
                            </v-stepper-content>
                        </template>
                        <v-stepper-content
                                :step="steps"
                                key="NEWSAMPLE"
                        >

                            <CaOrderSampleForm @newsample="addSample"></CaOrderSampleForm>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text style="max-height:280px">
                <v-data-table
                        :headers="controls.table.headers"
                        :items="form.samples"
                        item-key="qa"
                        :items-per-page="-1"
                        height="250"
                        hide-default-footer
                >
                    <template v-slot:item="{item, index}">
                        <tr >
                            <td @click="controls.currentStep = (index +1)"><v-btn class="text-left" tile text>{{item.qa}}</v-btn></td>
                            <td>{{item.manifest_id}}</td>
                            <td>
                                <span v-for="(test, index) in item.tests" :key="index">
                                    {{test.name}} {{(index+1 < item.tests.length) ? ',' : ''}}
                                </span>
                            </td>
                            <td><v-btn @click="removeSample(index)" color="error" small text icon><v-icon>delete</v-icon></v-btn></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="controls.showDialog = !controls.showDialog">Close Dialog</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green" dark @click="submit()">submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import recorded from '../../Lib/Recorded';
    import { nanoid } from 'nanoid'
    export default {
        name: "CreateOrder",
        components:{
            CaOrderSampleForm: () => import('../OrdersSampleForm'),
            CaSampleTypeDropdown: () => import('../DropdownSampleTypes')
        },
        data: () => ({
            controls:{
                showDialog: false,
                currentStep: 1,
                loading: false,
                table:{
                    headers: [
                        {text: 'Qa', value:'qa'},
                        {text: 'Manifest Id', value:'manifest_id'},
                        {text: 'Tests', value:'tests'},
                        {text: 'Remove', value:''},
                    ]
                }
            },
            form:{
                samples: [],
            }
        }),
        computed:{
            steps() {
                return this.form.samples.length + 1;
            },
        },
        props:{
            manifest:{
                default: false,
            },
            icon:{
                type:Boolean,
                default: false,
            }
        },
        mounted(){
            if(this.manifest){
                this.buildSamples();
            }
        },
        methods:{
            buildSamples(type = null){
              // this.form.samples = this.manifest.inventory_transfer_items
                this.form.samples = [];
                this.manifest.inventory_transfer_items.forEach(item => {
                    this.form.samples.push({
                        manifest_id: item.global_inventory_transfer_id,
                        order_id: null,
                        name: item.strain_name,
                        legal_type: item.intermediate_type,
                        qa: item.global_inventory_id,
                        lot: item.global_id,
                        type: type ? type.name : null,
                        weight: item.qty,
                        id: null,
                        customer_id: null,
                        sample_cert_type_uuid: null,
                        sample_type_uuid: null,
                        sample_type_name: null,
                        harvest_date: null,
                        unit_uuid: null,
                        unitName: null,
                        salt: null,
                        created_by: null,
                        tests: null,
                    })
                })
            },
            addSample(sample){
                this.form.samples.push(JSON.parse(JSON.stringify(sample)));
                this.$nextTick().then(() => {
                    this.controls.currentStep +=1;
                })
                console.log(this.form.samples, "came from form");
            },
            updateSample(oldSample,updatedSample){
                updatedSample = JSON.parse(JSON.stringify(updatedSample));
                let keys = Object.keys(updatedSample);
                for(let i in keys){
                    oldSample[keys[i]] = updatedSample[keys[i]]
                }
                this.controls.currentStep += 1;
            },
            setSampleTypes(type){
                this.form.samples.forEach(sample => {
                    sample.type = type.name;
                });
            },
            removeSample(index){
                this.form.samples.splice(index, 1);
                let currentStep = this.controls.currentStep;
                this.$nextTick().then(()=>{
                    if(this.form.samples.length > 0 && this.controls.currentStep !== 1){
                        if(this.controls.currentStep >= index +1){
                            this.controls.currentStep -=1;
                        }else{
                            this.controls.currentStep = 0;
                            this.$nextTick().then(() => {
                                this.controls.currentStep = currentStep;
                            })
                        }
                    }else{
                        this.controls.currentStep = 0;
                        this.$nextTick().then(() => {
                            this.controls.currentStep = 1;
                        })
                    }
                })
            },
            async submit(){
                this.controls.loading = true;
                await this.$store.$db().model('units').api().fetch({
                    where:{
                        key: "name",
                        value: "g"
                    }
                });
                let unit = this.$store.$db().model('units').query().first();
                let order_id = nanoid(10)
                for(let i in this.form.samples){
                    let sampleId =  await recorded.get('/factories/samples/highest');
                    sampleId = parseInt(sampleId.data) + 1;
                    this.form.samples[i].id = sampleId;
                    this.form.samples[i].unit_uuid = unit.uuid;
                    this.form.samples[i].order_id = order_id;
                    this.form.samples[i].created_by = this.$store.getters.id;
                    let sample = await this.$store.$db().model('samples').api().save(this.form.samples[i]);
                    for(let j in this.form.samples[i].tests){
                        await this.$store.$db().model('sampleTests').api().save({
                            sample_uuid: sample.response.data.uuid,
                            sample_test_type_uuid: this.form.samples[i].tests[j].uuid,
                            dfactor: 0,
                            dvolume: 0,
                            mass:null,
                            solvent_type_uuid: null,
                            unit_uuid: unit.uuid,
                            passed: 0,
                            complete: 0,
                            retest: 0,
                            active: 1,
                            created_by: this.$store.getters.id
                        })
                    }
                }
                this.controls.loading = false;
                this.$store.dispatch("showSuccess", "Done creating samples.");
                this.form.samples = [];
            }
        }
    }
</script>

<style scoped>

</style>
